import { render, staticRenderFns } from "./ReplaceHrDocumentDialog.vue?vue&type=template&id=6be585fa&scoped=true&"
import script from "./ReplaceHrDocumentDialog.vue?vue&type=script&lang=js&"
export * from "./ReplaceHrDocumentDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReplaceHrDocumentDialog.vue?vue&type=style&index=0&id=6be585fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be585fa",
  null
  
)

export default component.exports